import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ListagemClientes } from '../models_users/listagemClientes.model';
import { UsersInClientService } from '../UsersInClient.service';

@Component({
  selector: 'app-criacao-usuarios',
  templateUrl: './criacao-usuarios.component.html',
  styleUrls: ['./criacao-usuarios.component.scss']
})
export class CriacaoUsuariosComponent implements OnInit {

  constructor(private fb: FormBuilder, private usersincliente: UsersInClientService, private toastr: ToastrService, private route: Router) {
    this.criarForm();
  }

  usuariosform: FormGroup;
  listaCliente: ListagemClientes[];
  load: boolean;
  TypeOfPasswordInput = 'password';

  ngOnInit() {
    this.carregaListaCliente();
  }


  private dec2hex(number): string {
    const base = 16;
    const digito = new Array();
    let i = 0;

    while (number != 0) {
      i++;
      digito[i] = number % base;
      number = Math.floor(number / base);
    }
    let value = '';

    while (i >= 1) {
      switch (digito[i]) {
        case 10: { value += 'A'; break; }
        case 11: { value += 'B'; break; }
        case 12: { value += 'C'; break; }
        case 13: { value += 'D'; break; }
        case 14: { value += 'E'; break; }
        case 15: { value += 'F'; break; }
        default: { value += digito[i]; break; }
      }
      i--;
    }
    return value;
  }

  GeneratePassword(): void {
    const min = 32;
    const max = 126;
    let pass = '';
    for (let i = 1; i <= 10; i++) {
      const numberAsChar = min + Math.floor((Math.random() * (max - min)));  // 32 a 126
      let caracter = '%' + this.dec2hex(numberAsChar);
      caracter = unescape(caracter);
      pass += caracter;
    }
    // this.userService.UserRegistrationModel.controls.Cidade.setValue(this.selecionaCidade(res.uf, "sigla"));
    this.usuariosform.controls.Senha.setValue(pass);
    this.usuariosform.controls.ConfirmaSenha.setValue(pass);
  }

  /**
   * Altera a visibilidade do campo de senha
   */
  TogglePasswordDisplay(): void {
    this.TypeOfPasswordInput = this.TypeOfPasswordInput === 'text' ? 'password' : 'text';
  }


  carregaListaCliente() {
    this.load = true;
    this.usersincliente.GetallCliente().subscribe(
      (data: ListagemClientes[]) => {
        this.listaCliente = data;
        this.load = false;
      },
      (erro: any) => {
        this.toastr.error('Não foi possivel carregar!', 'Clientes');
        this.load = false;

      }
    );
  }

  criarForm() {
    this.usuariosform = this.fb.group({
      IdClienteSelecionado: ['', Validators.required],
      Email: ['', [Validators.email, Validators.required]],
      Login: ['', Validators.required],
      Senha: ['', Validators.required],
      ConfirmaSenha: ['', Validators.required],
      Nome: ['', Validators.required],
      NomeResponsavel: ['', Validators.required],
      NomeContato: ['', Validators.required],
      RoleSelecionada: ['', Validators.required],
    }, { validator: this.ValidRegistration });
  }

  ValidRegistration(fb: FormGroup) {



    const ConfirmPassword = fb.get('ConfirmaSenha');
    if (ConfirmPassword.errors == null || 'passwordMismatch' in ConfirmPassword.errors) {
      if (fb.get('ConfirmaSenha').value != ConfirmPassword.value) {
        ConfirmPassword.setErrors({ passwordMismatch: true });
      } else {
        ConfirmPassword.setErrors(null);
      }
    }
  }

  OnSubmitRegister() {
    this.usersincliente.register(this.usuariosform.value).subscribe(
      (res: any) => {
        this.toastr.success('Você está sendo redirecionado!', 'Concluido', { timeOut: 2000, progressBar: true });
        setTimeout(() => {
          this.route.navigateByUrl('/users/list');
        }, 2000);
      },
      err => {
        console.log(err);
        if (typeof err.error === 'string') {

          this.toastr.error(err.error, 'Cliente');
        } else {

          this.toastr.error('Não foi possivel realizar cadastro', 'Cliente');
        }
      }
    );
  }



















}
